module.exports = __webpack_public_path__ + "img/scholar.42cf057c.svg";